var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGetintouch = function SvgGetintouch(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 86,
    viewBox: "0 0 81 86",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2609 51.6957V76.0435C41.2609 77.8885 40.5279 79.6579 39.2233 80.9625C37.9187 82.2671 36.1493 83 34.3043 83H9.95652C8.11154 83 6.34212 82.2671 5.03752 80.9625C3.73292 79.6579 3 77.8885 3 76.0435V23.8696C3 22.0246 3.73292 20.2552 5.03752 18.9506C6.34212 17.646 8.11154 16.9131 9.95652 16.9131H23.8696",
    stroke: "#D1DBE1",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8696 30.8262H3",
    stroke: "#D1DBE1",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2609 69.0869H3",
    stroke: "#D1DBE1",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9128 23.8696H23.8694",
    stroke: "#D1DBE1",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.652 34.3043H72.7824C74.1662 34.3043 75.4932 33.7547 76.4717 32.7762C77.4501 31.7978 77.9998 30.4707 77.9998 29.087V8.21739C77.9998 6.83365 77.4501 5.50659 76.4717 4.52814C75.4932 3.54969 74.1662 3 72.7824 3H36.0433C34.6596 3 33.3325 3.54969 32.3541 4.52814C31.3756 5.50659 30.8259 6.83365 30.8259 8.21739V29.087C30.8259 30.4707 31.3756 31.7978 32.3541 32.7762C33.3325 33.7547 34.6596 34.3043 36.0433 34.3043H48.2172V44.7391L58.652 34.3043Z",
    stroke: "#D1DBE1",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6891 16.0251C54.1622 16.0251 53.6471 16.1814 53.2089 16.4741C52.7708 16.7669 52.4293 17.183 52.2277 17.6698C52.026 18.1566 51.9733 18.6923 52.0761 19.2091C52.1789 19.7259 52.4326 20.2006 52.8052 20.5732C53.1778 20.9458 53.6525 21.1996 54.1693 21.3024C54.6861 21.4052 55.2218 21.3524 55.7086 21.1507C56.1955 20.9491 56.6115 20.6076 56.9043 20.1695C57.197 19.7314 57.3533 19.2163 57.3533 18.6893C57.3533 17.9828 57.0726 17.3051 56.573 16.8055C56.0733 16.3058 55.3957 16.0251 54.6891 16.0251Z",
    fill: "#0058FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8656 16.0251C63.3387 16.0251 62.8236 16.1814 62.3855 16.4741C61.9473 16.7669 61.6059 17.183 61.4042 17.6698C61.2026 18.1566 61.1498 18.6923 61.2526 19.2091C61.3554 19.7259 61.6091 20.2006 61.9817 20.5732C62.3543 20.9458 62.829 21.1996 63.3459 21.3024C63.8627 21.4052 64.3983 21.3524 64.8852 21.1507C65.372 20.9491 65.7881 20.6076 66.0808 20.1695C66.3736 19.7314 66.5298 19.2163 66.5298 18.6893C66.5298 17.9828 66.2491 17.3051 65.7495 16.8055C65.2499 16.3058 64.5722 16.0251 63.8656 16.0251Z",
    fill: "#0058FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5744 73.1943C22.0474 73.1943 21.5323 73.3506 21.0942 73.6433C20.6561 73.9361 20.3146 74.3522 20.1129 74.839C19.9113 75.3258 19.8586 75.8615 19.9614 76.3783C20.0642 76.8951 20.3179 77.3698 20.6905 77.7424C21.0631 78.115 21.5378 78.3687 22.0546 78.4715C22.5714 78.5743 23.1071 78.5216 23.5939 78.3199C24.0807 78.1183 24.4968 77.7768 24.7895 77.3387C25.0823 76.9006 25.2386 76.3855 25.2386 75.8585C25.2386 75.1519 24.9579 74.4743 24.4582 73.9747C23.9586 73.475 23.2809 73.1943 22.5744 73.1943Z",
    fill: "#D1DBE1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2162 16.0251C44.6893 16.0251 44.1742 16.1814 43.736 16.4741C43.2979 16.7669 42.9564 17.183 42.7548 17.6698C42.5531 18.1566 42.5004 18.6923 42.6032 19.2091C42.706 19.7259 42.9597 20.2006 43.3323 20.5732C43.7049 20.9458 44.1796 21.1996 44.6964 21.3024C45.2132 21.4052 45.7489 21.3524 46.2357 21.1507C46.7226 20.9491 47.1386 20.6076 47.4314 20.1695C47.7241 19.7314 47.8804 19.2163 47.8804 18.6893C47.8804 17.9828 47.5997 17.3051 47.1001 16.8055C46.6004 16.3058 45.9228 16.0251 45.2162 16.0251Z",
    fill: "#0058FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGetintouch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/getintouch.f8ac1f75.svg";
export { ForwardRef as ReactComponent };